<!-- 菜品排行 -->
<template>
    <div id="home">
    	<van-nav-bar
		  	:title="$t('MenuRank.title')"
			left-arrow
			fixed
		  	@click-left="$router.go(-1)">
		</van-nav-bar> 
		<div class="contentWrapper">
			<van-cell-group>
				<span class="text">{{$t('MenuRank.text1')}}</span>
				<van-field
					class="inputAr"
					readonly  	
					right-icon="arrow" 	  	
					@click="showStartTimePicker = true" 	
					:value='menus.startTime'
				/> 
				<!-- 弹框 -->
				<van-popup v-model="showStartTimePicker" position="bottom">
					<van-datetime-picker
						v-model="currentDate"
						type="date"
						:max-date="maxDate"
						:confirm-button-text="$t('vantText.confirm')"
						:cancel-button-text="$t('vantText.cancel')"
						@cancel="showStartTimePicker = false"
						@change="changeStartTime()"
						@confirm="onStartChangeConfirm"
					/>
				</van-popup>
				<span class="text">{{$t('MenuRank.text')}}</span>
				<van-field
					class="inputAr"
					readonly
					right-icon="arrow" 		
					@click="showEndTimePicker = true"
					:value='menus.endTime'
				/>  
				<!-- 弹框 -->
				<van-popup v-model="showEndTimePicker" position="bottom">
					<van-datetime-picker
						v-model="currentEndDate"
						type="date"
						:min-date="minDate"
						:confirm-button-text="$t('vantText.confirm')"
						:cancel-button-text="$t('vantText.cancel')"
						@cancel="showEndTimePicker = false"
						@change="changeEndTime()"
						@confirm="onChangeConfirm"
					/>
				</van-popup>
			</van-cell-group>
			<div class="divideLine"></div>
			<van-tabs v-model="active" @click=onMenuRank>
				<van-tab :title="$t('MenuRank.price')">
					<!-- 表头 -->
					<van-cell>
						<van-row class='title'>
							<van-col span="3" class='rank'>{{$t('MenuRank.rank')}}</van-col>
							<van-col span="10" class='noExceed'>{{$t('MenuRank.cookName')}}</van-col>
							<van-col span="6">{{$t('MenuRank.price1')}}({{currency}})</van-col>
							<van-col span="5">{{$t('MenuRank.num')}}</van-col>	
						</van-row>
					</van-cell>
					<van-cell v-for="(item,index) in menusList" :key='index' >
						<van-row>
							<van-col span="3">{{index+1}}</van-col>
							<van-col span="10" class="noExceed">{{item.name}}</van-col>
							<van-col span="6">{{item.price}}</van-col>
							<van-col span="5">{{item.number}}{{$t('MenuRank.portion')}}</van-col>	
						</van-row>
					</van-cell>
				</van-tab>
				
				<van-tab :title="$t('MenuRank.portionNum')" >
					<van-cell>
						<van-row class='title'>
							<van-col span="3" class='rank'>{{$t('MenuRank.rank')}}</van-col>
							<van-col span="10" class='noExceed'>{{$t('MenuRank.cookName')}}</van-col>
							<van-col span="6">{{$t('MenuRank.price1')}}({{currency}})</van-col>
							<van-col span="5">{{$t('MenuRank.num')}}</van-col>	
						</van-row>
					</van-cell>
					<van-cell v-for="(item,index) in menusList" :key='index'>
						<van-row>
							<van-col span="3">{{index+1}}</van-col>
							<van-col span="10" class="noExceed">{{item.name}}</van-col>
							<van-col span="6">{{item.price}}</van-col>
							<van-col span="5">{{item.number}}{{$t('MenuRank.portion')}}</van-col>	
						</van-row>
					</van-cell>
				</van-tab>
			</van-tabs>
		</div>
    </div>
</template>
<script>
  	export default {
  		data(){
  			return{
  				active: 2,
  				menusList:[],
  				menus:{
  					startTime:this.formatDateYMD1(new Date()),
  					endTime:this.formatDateYMD(new Date())
  				},
  				maxDate:new Date(),
  				minDate:new Date(),
  				currentDate:new Date(),
  				currentEndDate:new Date(),
  				showStartTimePicker:false,
  				showEndTimePicker:false,
  				price:'price',
				number:'number',
				currency:''
  			}
  		},
  		mounted(){
  			// this.menus.startTime=this.formatDateYMD(new Date());
  			// this.menus.endTime=this.formatDateYMD(new Date());
			  this.getMenuRank(this.price);
			  this.getCurrency()
  		},
  		methods:{
  			getMenuRank(rankType){
				this.$axios({
	                method: 'PATCH',
	                headers: {
	                    "Authorization": 'Bearer '+sessionStorage.token,
	                },
	                url: this.$build+'/api/store/'+sessionStorage.actShopId+'/menuRank',
	                data:{
	                	startday:this.menus.startTime,
	                	endday:this.menus.endTime,
	                	type:rankType
	                }
	            }).then(res => {
					console.log(res);
	            	if(res.data.status==200){
	                	this.menusList=res.data.data;
	            	}else{
	            		for (var item in res.data.error) {
	            			this.$toast({
			            		type:'fail',
			            		message:res.data.error[item],
			            	});
	            		}
	            	}
	            }).catch(err => {
	            	
	            });
	    	},
  			onChangeConfirm(){
				this.menus.endTime=this.formatDateYMD(this.currentEndDate);
	    		this.showEndTimePicker = false;
	    		console.log(this.menus.endTime);
	    		console.log(this.menus.startTime);
	    		this.changeStatus();
	    	},
	    	onStartChangeConfirm(){
	    		this.menus.startTime=this.formatDateYMD(this.currentDate);
	    		this.showStartTimePicker = false;
	    		this.changeStatus();
	    	},
	    	//开始时间显示前一个月
	    	formatDateYMD1(value){
			    if (!value){ 
			        return '';
			    }else{
			        var date = new Date(value);
			        var Y = date.getFullYear();
			        var M = (date.getMonth()+1);
			        var D = date.getDate();

			        //获取前一个月的日期
			        var Y2=Y;
			        var M2=parseInt(M) - 1;
			        //如果月为0则显示去年最后一个月12月
			        if(M2==0){
			        	Y2 = parseInt(Y2) - 1;
        				M2 = 12;
			        }
			        var D2=D;
			        var DS2=new Date(Y2, M2, 0); 
			        DS2=DS2.getDate(); 
			        if(D2>DS2){
			        	D2=DS2
			        }
			        if(M2<10){
			        	M2=M2;
			        }
			        var t2=Y2 + '/' + M2 + '/' + D2;
			        return t2;
			    }
			},
	    	formatDateYMD(value){
			    if (!value){ 
			        return '';
			    }else{
			        var date = new Date(value);
			        var Y = date.getFullYear()+'/';
			        var M = (date.getMonth()+1)+ '/';
			        var D = date.getDate();
			        return Y+M+D;
			    }
			},
			changeStartTime(){
				this.menus.startTime=this.formatDateYMD(this.currentDate);
				this.minDate=this.currentDate;
			},
			changeEndTime(){
				this.menus.endTime=this.formatDateYMD(this.currentEndDate);
				this.maxDate=this.currentEndDate;
			},
			onMenuRank(name,title){
				if(title== this.$t('MenuRank.price')){
					this.getMenuRank(this.price);
				}else if(title == this.$t('MenuRank.portionNum')){
					this.getMenuRank(this.number);
				}
			},
			changeStatus(){
				if(this.active==0){
	    			this.getMenuRank(this.price);
	    		}else{
	    			this.getMenuRank(this.number);
	    		}
			},
			// 获取店铺设置的货币
			getCurrency(){
				this.$axios({
					method: 'get',
					headers: {
						"Authorization": 'Bearer '+sessionStorage.token,
					},
					url: this.$build+'/api/store/'+sessionStorage.actShopId+'/currency',
				}).then(res => {
					console.log(res);
					if(res.data.status==200){
						this.currency = res.data.data.unit
					}else{
						for (var item in res.data.error) {
							this.$toast({
								type:'fail',
								message:res.data.error[item],
							});
						}
					}
				}).catch(err => {
					this.$toast({
						type:'fail',
						message:this.$t('EditDish.message'),
					});
				});
			},
  		}
  	}
</script>
<style scoped>
	/deep/ .van-nav-bar .van-icon{
		font-size: 24px;
		color: #fff;
	}
	/deep/ .van-cell{
		line-height: 24px;
	}
	/deep/ .van-tabs__line{
		background-color: #fd3f3f;
	}
	/deep/ .van-picker__cancel,/deep/ .van-picker__confirm{
		color: #2f75f7;
	}
	/deep/ .van-field__right-icon{
		margin-right:-10px;
		padding:0 5px;
	}
	.contentWrapper{
		/* padding-top: 47px; */
	}
	/*分割线*/
	.divideLine{
		height: 5px;
		background: #F3F5F7;
	}
	.van-cell-group{
		padding: 15px;
		display: flex;
		justify-content: space-between;
	}
	.inputAr{
		width: 40%;
		/*height: 35px;*/
		line-height: 15px;
		border: 2px solid #000;
		border-radius: 50px;
		font-size: 14px;
	}
	/* 至 */
	.text{
		line-height: 35px
	}
	.title{
		font-size: 14px;
		color: #444;
	}
	
</style>


// WEBPACK FOOTER //
// src/Report/MenuRank.vue